import { render, staticRenderFns } from "./CadastroProduto.vue?vue&type=template&id=46de3af2&"
import script from "./CadastroProduto.vue?vue&type=script&lang=js&"
export * from "./CadastroProduto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports